// import { encodeSSFArgument } from '@/utils/templateEngine';
import googleSheets from '@/config/googleSheets'; // Default to generic number SSF format, with
// auto decimal trimming, and auto abbreviation

export const DEFAULT_CHART_VALUE_TEMPLATE = `{{value | ssf ${googleSheets.formats.number} | trim_dec | abbr auto}}`; // Sections offically supported by widget

export const SECTION_NAMES = {
  form: 'Form',
  list: 'List',
  overview: 'Overview',
  table: 'Table',
  stackedBars: 'StackedBars',
  stackedBarChart: 'StackedBarChart',
  barChart: 'BarChart',
  lineChart: 'LineChart',
  treeMap: 'TreeMap',
  receipt: 'Receipt',
  pieDoughnut: 'PieDoughnut',
  scatter: 'Scatter',
  bubble: 'Bubble',
  gaugeChart: 'GaugeChart',
  radarChart: 'RadarChart'
}; // Required to segregate charts from other widgets

export const CHART_WIDGET_TAGS = ['chart']; // User editable widget attributes

export const EDITABLE_WIDGET_ATTRS = ['elementId', 'title', 'description', 'config', 'layout', 'sections', 'theme', 'themeMode'];